

import * as THREE from 'three';
import { ARButton } from "three/examples/jsm/webxr/ARButton"
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { useEffect, useRef, useState } from 'react';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

import refregratorimg from "../assets/1.png"
import ovenimg from "../assets/2.jpg"
import hoodimg from "../assets/3.jpg"
import dishwasherimg from "../assets/4.jpg"
import close from "../assets/icons8-close-24.png"
import fullscreneimg from "../assets/full-size.png"
// import arimg from "../assets/model.png"
import arimg from "../assets/ar.png"
import boximg from "../assets/box.png"
import left from "../assets/icons8-forward-30.png"
import Loading from './Loading/Loading';

export default function Webxr() {

    console.log("webxr");
    let door = ['model/NamakAbrood-dark.glb']
    


    const ShowModal = () => {
        document.querySelector(".modal").style.display = "flex"
    }



    const OpenAR = () => {
       
        document.getElementById('ARButton').click()
        current_object.visible = false;
        renderer.xr.enabled = true;
        isAR = true;
    }

    function toggleFullScreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }


    const slideIndex = useRef(1);

    // function changeModel(item) {
    //     switch (item) {
    //         case 'ref': {
    //             product.current = 'refregerator'
    //             document.getElementById("Loading").style.display = "flex"
    //             slideIndex.current = 1
    //             setChangeModel(refregerator[0])
    //             document.querySelector(".modal").style.display = "none"
    //             break

    //         }

    //         case 'oven': {
    //             product.current = 'oven'
    //             document.getElementById("Loading").style.display = "flex"
    //             slideIndex.current = 1
    //             setChangeModel(oven[0])

    //             document.querySelector(".modal").style.display = "none"
    //             break

    //         }

    //         case 'hood': {
    //             product.current = 'hood'
    //             document.getElementById("Loading").style.display = "flex"
    //             slideIndex.current = 1

    //             setChangeModel(hood[0])
    //             // model[0].src = hood[0]
    //             document.querySelector(".modal").style.display = "none"
    //             break

    //         }
    //         case 'dishwasher': {
    //             product.current = 'dishwasher'
    //             document.getElementById("Loading").style.display = "flex"
    //             slideIndex.current = 1

    //             setChangeModel(dishwasher[0])
    //             document.querySelector(".modal").style.display = "none"
    //             break

    //         }


    //     }
    // }







    var container;
    let camera, scene, renderer;
    var controller;

    var reticle, pmremGenerator, current_object, controls, isAR, envmap;

    var hitTestSource = null;
    let hitTestSourceRequested = false;



    useEffect(() => {


        init();
        animate();
        loadModel(door[0])

        if (document.querySelector("#ARButton")) {
            document.querySelector("#ARButton").style.opacity = 1
            document.querySelector("#ARButton").style.backgroundColor = "red"
            document.querySelector("#ARButton").style.bottom = '100px'
            document.querySelector("#ARButton").style.zIndex = -1

            document.querySelector("#ARButton").style.position = 'unset'


        }

        document.getElementById('place-button').addEventListener("click", function () {
            arPlace();
        })
    }, [])





    function arPlace() {
        if (reticle.visible) {
            // current_object.scale.set(0.01,0.01,0.01)
            current_object.position.setFromMatrixPosition(reticle.matrix);
            console.log( current_object.position);
            current_object.visible = true;
        }
    }

    function loadModel(model) {

        var loader = new GLTFLoader()
        const draco = new DRACOLoader();
        draco.setDecoderConfig({ type: 'js' });
        draco.setDecoderPath('/draco/');
        loader.setDRACOLoader(draco);


        loader.load(model, function (glb) {
            glb.scene.position.set(0, -50, 0)
            // glb.scene.scale.set(0.3,0.3,0.3)
            glb.scene.name = model
            current_object = glb.scene;
            scene.add(current_object);

            arPlace();

            document.getElementById("Loading").style.display = "none"

            render();
        });
    }

    function init() {
        container = document.createElement('div');
        document.getElementById("container").appendChild(container);

        scene = new THREE.Scene();
        scene.environment = new RGBELoader().load('christmas_photo_studio_07_1k.hdr');
        scene.environment.mapping = THREE.EquirectangularReflectionMapping;
        window.scene = scene;

        camera = new THREE.PerspectiveCamera(70, document.body.offsetWidth / document.body.offsetHeight, 0.1, 1000);
        // camera.position.set(0,35, -60)
        camera.position.set(0,10, -90)
        camera.lookAt(0,0,0)


        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true ,preserveDrawingBuffer:true});
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(document.body.offsetWidth, document.body.offsetHeight);
        // renderer.xr.enabled = true;
        container.appendChild(renderer.domElement);

        pmremGenerator = new THREE.PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();

        controls = new OrbitControls(camera, renderer.domElement);
        // controls.addEventListener('change', render);
        // controls.minDistance = 2;
        // controls.maxDistance = 10;
        controls.target.set(0, 0, -0.2);
        controls.enableDamping = true;
        controls.dampingFactor = 0.05;


        //AR SETUP

        let options = {
            requiredFeatures: ['hit-test'],
            optionalFeatures: ['dom-overlay'],
        }

        options.domOverlay = { root: document.getElementById('contents') };

        document.body.appendChild(ARButton.createButton(renderer, options));

        //document.body.appendChild( ARButton.createButton( renderer, { requiredFeatures: [ 'hit-test' ] } ) );

        //

        reticle = new THREE.Mesh(
            new THREE.RingGeometry(0.15, 0.2, 32).rotateX(- Math.PI / 2),
            new THREE.MeshBasicMaterial()
        );
        reticle.matrixAutoUpdate = false;
        reticle.visible = false;
        scene.add(reticle);

        //

        window.addEventListener('resize', onWindowResize, false);

        renderer.domElement.addEventListener('touchstart', function (e) {
            e.preventDefault();
            touchDown = true;
            touchX = e.touches[0].pageX;
            touchY = e.touches[0].pageY;
        }, false);

        renderer.domElement.addEventListener('touchend', function (e) {
            e.preventDefault();
            touchDown = false;
        }, false);

        renderer.domElement.addEventListener('touchmove', function (e) {
            e.preventDefault();

            if (!touchDown) {
                return;
            }

            deltaX = e.touches[0].pageX - touchX;
            deltaY = e.touches[0].pageY - touchY;
            touchX = e.touches[0].pageX;
            touchY = e.touches[0].pageY;

            rotateObject();

        }, false);

    }

    let touchDown, touchX, touchY, deltaX, deltaY;

    function rotateObject() {
        if (current_object) {
            current_object.rotation.y += deltaX / 100;
        }
    }

    function onWindowResize() {

        camera.aspect = document.body.offsetWidth / document.body.offsetHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(document.body.offsetWidth, document.body.offsetHeight);

    }
    function animate() {
        renderer.setAnimationLoop(render);
        requestAnimationFrame(animate);
        controls.update();
    }


    function render(timestamp, frame) {
        if (frame && isAR) {

            console.log(current_object.position);
            var referenceSpace = renderer.xr.getReferenceSpace();
            var session = renderer.xr.getSession();


            if (hitTestSourceRequested === false) {

                session.requestReferenceSpace('viewer').then(function (referenceSpace) {

                    session.requestHitTestSource({ space: referenceSpace }).then(function (source) {

                        hitTestSource = source;

                    });

                });

                session.addEventListener('end', function () {

                    renderer.xr.enabled = false;

                    hitTestSourceRequested = false;
                    hitTestSource.cancel()
                    hitTestSource = null;

                    isAR = false;

                    reticle.visible = false;

                    if (current_object != null) {
                        scene.remove(current_object);
                    }
                    loadModel(current_object.name)

                    document.getElementById("place-button").style.display = "none";
                    document.getElementById("contents").style.display = "block";
                    camera.position.set(0, 0, 2)
                    camera.rotation.set(0, 0, 0)
                    camera.aspect = document.body.offsetWidth / document.body.offsetHeight;
                    camera.updateProjectionMatrix();

                    renderer.setSize(document.body.offsetWidth, document.body.offsetHeight);





                });

                hitTestSourceRequested = true;

            }
            if (hitTestSource) {

                var hitTestResults = frame.getHitTestResults(hitTestSource);

                if (hitTestResults.length) {

                    var hit = hitTestResults[0];

                    document.getElementById("place-button").style.display = "block";

                    reticle.visible = true;

                    reticle.matrix.fromArray(hit.getPose(referenceSpace).transform.matrix);

                } else {

                    reticle.visible = false;

                    document.getElementById("place-button").style.display = "none";

                }

            }

        }


        renderer.render(scene, camera);

    }



    return (

        <>

            <Loading />
            <div id="contents">

            {/* <div className="panelTop" >
        <div className="boxpanel">
            <img className="img" src={boximg} alt="Image 1"/>
            <img className="img" src={arimg} onClick={OpenAR} alt="Image 2"/>
           </div>
           </div> */}


                <div className="panelTop" id="panelTop">
                    <div className="boxpanel">
                         <img  className="img" src={arimg} onClick={OpenAR} />
                    </div>
                </div>


                <div id="container" style={{ zIndex: 0 }}></div>

                <button type="button" id="place-button">PLACE</button>

            </div>

        </>

    )
}